import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { SpsMultiSelectTagComponent } from "../components/index";

@NgModule({
    imports: [CommonModule],
    declarations: [
        SpsMultiSelectTagComponent
    ],
    exports: [
        SpsMultiSelectTagComponent
    ]
})
export class SpsMultiSelectModule {}
